import '@bjb/bjb-web-components/dist/components/jb-bypass-block/jb-bypass-block.js';

window.addEventListener('jb-bypass-block:navigate', (evt: CustomEvent) => {
  (evt.target as HTMLElement)?.blur();
  document.dispatchEvent(
    new CustomEvent('jb-focus-fly:reset', { bubbles: true, composed: true })
  );

  if (evt.detail.name === 'navigation') {
    const navigation = document.querySelector('jb-navigation');
    (
      navigation?.shadowRoot.querySelector('jb-burger-icon') as HTMLElement
    )?.click();
  }

  if (evt.detail.name === 'eservices') {
    const eservices = document.querySelector('jb-navigation');
    (
      eservices?.shadowRoot.querySelector('jb-e-service-icon') as HTMLElement
    )?.click();
  }
});
